import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const getAllAzureUsers = async (latestTenant: string, subId: string) => {

    let url = `${NGROK}/api/azure/v1/users?tenantName=${latestTenant}`;
    if (subId) {
        url += `&subscriptionId=${subId}`;
    }
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data
};
export const getAllAzureGroupsAndRoles = async (latestTenant: string, subId: string) => {
    let url = `${NGROK}/api/azure/v1/users/getRolesAndGroups?tenantName=${latestTenant}`;
    if (subId) {
        url += `&subId=${subId}`;
    }
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const fetchAzureSubscriptionList = async (latestTenant: string) => {
    let url = `${NGROK}/api/azureResources/v1/all?tenantName=${latestTenant}&type=SUBSCRIPTION`;
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const fetchAzureConfiguredSubscriptionIds = async (latestTenant: string): Promise<string[]> => {
    const data = await apiClient<any>({
        method: "GET",
        url: `${NGROK}/api/azure/auth/configuration?tenantName=${encodeURIComponent(latestTenant)}`
    });
    return Array.isArray(data?.subscriptionIds) ? data.subscriptionIds : [];
};
